import { render, staticRenderFns } from "./Restrictor.vue?vue&type=template&id=d182fa8a&scoped=true&"
import script from "./Restrictor.vue?vue&type=script&lang=js&"
export * from "./Restrictor.vue?vue&type=script&lang=js&"
import style0 from "./Restrictor.vue?vue&type=style&index=0&id=d182fa8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d182fa8a",
  null
  
)

export default component.exports